/* eslint-disable @typescript-eslint/no-inferrable-types */
import {
  PaginatedPayments,
  PaymentDataEntryForm,
  SubmitPaymentResponse,
} from "types/model.types";
import { authApi } from "./";

const apiPaymentPrefix = "payment";

export const getPayments = async (
  pageNumber: number = 1,
  pageSize: number = 30,
): Promise<void | PaginatedPayments> => {
  const { data } = await authApi.post<PaginatedPayments>(
    `${apiPaymentPrefix}/get`,
    {
      pageNumber,
      pageSize,
    },
  );
  return data;
};
export const deleteAdminPayment = async (id: number): Promise<void | any> => {
  const { data } = await authApi.post<any>(
    `${apiPaymentPrefix}/deleteAdminPayment`,
    {
      id,
    },
  );
  return data;
};
export const submitPayment = async (
  payload: any,
): Promise<void | SubmitPaymentResponse> => {
  const { data } = await authApi.post<SubmitPaymentResponse>(
    `${apiPaymentPrefix}/submit`,
    payload,
  );
  return data;
};

export const getPaymentAndDetails = (
  id: number,
): Promise<PaymentDataEntryForm> => {
  return authApi
    .post<PaymentDataEntryForm>(`${apiPaymentPrefix}/getPaymentAndDetails`, {
      id,
    })
    .then((res) => res.data);
};
export const deletePaymentDetails = async (
  paymentId: number,
  paymentDetailIds: number[],
): Promise<void | any> => {
  const { data } = await authApi.post<any>(
    `${apiPaymentPrefix}/deleteDetails`,
    {
      paymentId,
      paymentDetailIds,
    },
  );
  return data;
};
